// Generated by ts-to-zod
import { z } from 'zod';
import {
    InjectionsEntity,
    VACCINATION_STATUS,
    DENTAL_ENTITY_TYPE,
    HXNG_MAPPED,
    HXNG_STATUS,
} from './../prescription-types-bundle';

export const careCanvasSchema = z.object({
    id: z.string(),
    name: z.string(),
    final_image: z.string(),
});

export const ipdAdmissionSchema = z.object({
    advised: z.boolean().optional(),
    include_procedures: z.boolean().optional(),
    notes: z.string().optional(),
});

export const procedureSchema = z.object({
    id: z.string(),
    name: z.string(),
    date: z.string().optional(),
    notes: z.string().optional(),
});

export const opSpecSchema = z.object({
    eye: z
        .object({
            value: z.string().optional(),
        })
        .optional(),
    sph: z
        .object({
            id: z.string(),
            value: z.string().optional(),
            custom: z.string().optional(),
        })
        .optional(),
    cyl: z
        .object({
            id: z.string(),
            value: z.string().optional(),
            custom: z.string().optional(),
        })
        .optional(),
    axis: z
        .object({
            id: z.string(),
            value: z.string().optional(),
            custom: z.string().optional(),
        })
        .optional(),
    add: z
        .object({
            id: z.string(),
            value: z.string().optional(),
            custom: z.string().optional(),
        })
        .optional(),
    dva: z
        .object({
            id: z.string(),
            value: z.string().optional(),
            custom: z.string().optional(),
        })
        .optional(),
    nva: z
        .object({
            id: z.string(),
            value: z.string().optional(),
            custom: z.string().optional(),
        })
        .optional(),
});

export const opSpecElementSchema = opSpecSchema.extend({
    id: z.string(),
});

export const opIopSchema = z.object({
    eye: z
        .object({
            value: z.string().optional(),
        })
        .optional(),
    nct: z
        .object({
            id: z.string(),
            value: z.string().optional(),
            custom: z.string().optional(),
        })
        .optional(),
    gat: z
        .object({
            id: z.string(),
            value: z.string().optional(),
            custom: z.string().optional(),
        })
        .optional(),
    cct: z
        .object({
            id: z.string(),
            value: z.string().optional(),
            custom: z.string().optional(),
        })
        .optional(),
    ciop: z
        .object({
            id: z.string(),
            value: z.string().optional(),
            custom: z.string().optional(),
        })
        .optional(),
});

export const opIopElementSchema = opIopSchema.extend({
    id: z.string(),
});

export const opVisionSchema = z.object({
    eye: z
        .object({
            value: z.string().optional(),
        })
        .optional(),
    ucdva: z
        .object({
            id: z.string(),
            value: z.string().optional(),
            custom: z.string().optional(),
        })
        .optional(),
    ucnva: z
        .object({
            id: z.string(),
            value: z.string().optional(),
            custom: z.string().optional(),
        })
        .optional(),
    ph: z
        .object({
            id: z.string(),
            value: z.string().optional(),
            custom: z.string().optional(),
        })
        .optional(),
    bcdva: z
        .object({
            id: z.string(),
            value: z.string().optional(),
            custom: z.string().optional(),
        })
        .optional(),
    bcnva: z
        .object({
            id: z.string(),
            value: z.string().optional(),
            custom: z.string().optional(),
        })
        .optional(),
});

export const opVisionElementSchema = opVisionSchema.extend({
    id: z.string(),
});

export const iMilestoneCategorySchema = z.union([
    z.literal('ek-7084767782'),
    z.literal('ek-1025408070'),
    z.literal('ek-9916604356'),
    z.literal('ek-9994397806'),
]);

export const iMilestoneStatusSchema = z.union([
    z.literal('achieved'),
    z.literal('under_observation'),
    z.literal('delayed'),
    z.literal('achieved_delay'),
    z.literal('achieved_early'),
    z.literal('achieved_unknown'),
]);

export const iMilestoneHistorySchema = z.object({
    id: z.string(),
    notes: z.string().optional(),
    status: iMilestoneStatusSchema.optional(),
    age: z
        .object({
            unit: z.string().optional(),
            value: z.string(),
        })
        .optional(),
    categoryId: iMilestoneCategorySchema,
    name: z.string(),
    category: z.string(),
});

export const vaccinationStatusSchema = z.nativeEnum(VACCINATION_STATUS);

export const iVaccinationStatusSchema = z.union([
    z.literal(VACCINATION_STATUS.DUE),
    z.literal(VACCINATION_STATUS.GIVEN),
    z.literal(VACCINATION_STATUS.MISSED),
    z.literal(VACCINATION_STATUS.PATIENT_REFUSED),
]);

export const iVaccineStatusSchema = z.object({
    id: z.string(),
    status: iVaccinationStatusSchema.optional(),
    date: z.string().optional(),
    brandId: z.string().optional(),
    batchNumber: z.string().optional(),
    notes: z.string().optional(),
    diseaseId: z.string(),
    doseNo: z.number(),
    ageGroup: z.string().optional(),
    name: z.string(),
});

export const surfaceSchema = z.object({
    id: z.string(),
    name: z.string(),
});

export const dentalEntityTypeSchema = z.nativeEnum(DENTAL_ENTITY_TYPE);

export const dentalExaminationSchema = z.object({
    entity_id: z.string().optional(),
    id: z.string(),
    name: z.string(),
    teeth_id: z.string().optional(),
    surfaces: z.array(surfaceSchema).optional(),
    since: z.string().optional(),
    remark: z.string().optional(),
    group_id: z.string().optional(),
    type: dentalEntityTypeSchema.optional(),
    index: z.number().optional(),
});

export const attachmentSchema = z.object({
    title: z.string(),
    description: z.string(),
    link: z.string(),
    file_type: z.string(),
    templateId: z.string().optional(),
});

export const refRangeSchema = z.object({
    low: z.string().optional().nullable(),
    high: z.string().optional().nullable(),
});

export const unitSchema = z.object({
    name: z.string(),
    id: z.string().optional(),
    refRange: refRangeSchema.optional(),
});

export const interpretationSchema = z.object({
    value: z.string(),
    id: z.string(),
    eka_id: z.string().optional(),
    name_list: z.array(z.string()).optional(),
});

export const allUnitsEntitySchema = z.object({
    name: z.string(),
    id: z.string(),
    refRange: refRangeSchema.optional(),
});

export const labVitalEntitySchema = z.object({
    id: z.string(),
    name: z.string(),
    unit_dislay_name: z.string().optional(),
    value: z.union([z.string(), z.number()]).optional(),
    interpretation: interpretationSchema.optional(),
    date: z.string().optional(),
    remark: z.string().optional(),
    unit: unitSchema.optional(),
    all_units: z.array(allUnitsEntitySchema).optional().nullable(),
    is_panel: z.boolean().optional(),
});

export const nameSchema = z.object({
    l: z.string(),
    f: z.string(),
});

export const docNetworkEntitySchema = z.object({
    name: nameSchema,
    specialized: z.string(),
    pic: z.string(),
    _id: z.string(),
    username: z.string(),
    points: z.number(),
    area: z.string(),
    city: z.string(),
    location: z.string(),
    exprience: z.string().optional(),
});

export const phoneSchema = z.object({
    code: z.string(),
    value: z.string(),
});

export const doctorReferClinicAddressSchema = z.object({
    _id: z.string().optional(),
    name: z.string().optional(),
    line: z.string().optional(),
    landmark: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    city_id: z.string().optional(),
    place_id: z.string().optional(),
    pincode: z.string().optional(),
    coordinates: z.string().optional(),
    gplacesid: z.string().optional(),
});

export const docEntitySchema = z.object({
    id: z.string().optional(),
    referred_doctor_url: z.string().optional(),
    name: nameSchema.optional(),
    phone: phoneSchema.optional(),
    clinic: doctorReferClinicAddressSchema.optional(),
    note: z.string().optional(),
    s_name: z.string().optional(),
    s_id: z.string().optional(),
    type: z.union([z.literal('doctor'), z.literal('speciality')]).optional(),
});

export const notesSchema = z.object({
    id: z.string(),
    text: z.string(),
    parsedText: z.string(),
});

export const advicesEntitySchema = z.object({
    id: z.string(),
    text: z.string(),
    parsedText: z.string(),
});

export const followupSchema = z.object({
    date: z.string().optional(),
    appointmentId: z.string().optional(),
    optionId: z.string().optional(),
    notes: z.string().optional(),
});

export const labTestsEntityOrProceduresEntitySchema = z.object({
    name: z.string(),
    id: z.string(),
    remark: z.string().optional(),
    book: z.boolean().optional(),
    test_on: z.string().optional(),
    repeat_on: z.string().optional(),
    type: z.string().optional(),
    content: z.array(z.string()).optional(),
    vendor_names: z.array(z.string()).optional(),
    vendor_ids: z.array(z.string()).optional(),
    hxng_only: z.boolean().optional(),
});

export const medDoseSchema = z.object({
    id: z.string().optional(),
    value: z.union([z.string(), z.number()]).optional(),
    unit: z.string().optional(),
    custom: z.string().optional(),
    timing: z.union([z.date(), z.string()]).optional(),
});

export const infusionRateSchema = z.object({
    total_volume: medDoseSchema.optional(),
    infusion_time: medDoseSchema.optional(),
    iv_drop_rate: medDoseSchema.optional(),
    iv_rate: medDoseSchema.optional(),
});

export const frequencySchema = z.object({
    type: z.string().optional(),
    code: z.string().optional(),
    onceEvery: z
        .object({
            value: z.string(),
            unit: z.string(),
        })
        .optional(),
    custom: z.string().optional(),
    time_split: z.array(medDoseSchema).optional(),
});

export const durationSchema = z.object({
    value: z.union([z.string(), z.number()]).optional(),
    unit: z.string().optional(),
    custom: z.string().optional(),
});

export const injectionsEntitySchema: z.ZodSchema<InjectionsEntity> = z.lazy(() =>
    z.object({
        name: z.string(),
        id: z.string(),
        generic_name: z.string(),
        form: z.string(),
        df_id: z.string().optional(),
        dosage_form: z.string().optional(),
        route: z.string(),
        dose: medDoseSchema,
        infusion_rate: infusionRateSchema,
        frequency: frequencySchema,
        duration: durationSchema,
        timing: z.string(),
        instructions: z.string().optional(),
        tapering_dose: z.array(injectionsEntitySchema).optional(),
        added_drug: z.array(injectionsEntitySchema).optional(),
        actual_name: z.string().optional(),
    }),
);

export const medDoseInfoSchema = z.object({
    dose: medDoseSchema.optional(),
    area: z
        .object({
            name: z.string(),
            id: z.string(),
        })
        .optional(),
    frequency: frequencySchema.optional(),
    timing: z.string().optional(),
    duration: durationSchema.optional(),
    quantity: z
        .object({
            custom: z.string().optional(),
        })
        .optional(),
    instruction: z.string().optional(),
    start_from: z
        .object({
            text: z.string(),
            value: z.string(),
            unit: z.string(),
        })
        .optional(),
    to_day: z
        .object({
            text: z.string(),
            value: z.string(),
            unit: z.string(),
        })
        .optional(),
});

export const optionSourceSchema = z.union([
    z.literal('COPILOT'),
    z.literal('GENIE'),
    z.literal('MDB'),
    z.literal('SUBSTITUTE'),
    z.literal('API_SEARCH'),
    z.literal('SUGGESTED'),
    z.literal('CUSTOM'),
    z.literal('SA'),
    z.literal('SUGGESTED/COMPLEMENTARY'),
    z.literal('BORROW'),
    z.literal('MAGIC_BOX'),
]);

export const labelTypeSchema = z.union([
    z.literal('AS_EMPTY'),
    z.literal('AS_INLINE_SEARCH'),
    z.literal('AS_INLINE_EMPTY'),
    z.literal('AS_SEARCH'),
    z.literal('CHIPS'),
    z.literal('ADD_DRUG_DIALOG'),
    z.literal('BULK_DRUG_DIALOG'),
    z.literal('GD_SUGGESTED'),
    z.literal('GD_SEARCH_REPLACE'),
    z.literal('GD_ADD_MEDICINES'),
    z.literal('PAD_ADD_DRUG_DIALOG'),
    z.literal('PAD_FIX_STRIP'),
    z.literal('SNACKING_QUESTIONS'),
    z.literal('SNACKING_QUESTIONS_NEW'),
    z.literal('POPUP'),
]);

export const pxElSourceTrackSchema = z.object({
    track: z
        .object({
            label: labelTypeSchema.optional(),
            index: z.number().optional(),
            source: z.union([optionSourceSchema, z.string()]).optional(),
            columnIndex: z.number().optional(),
        })
        .optional(),
});

export const hxngMappedSchema = z.nativeEnum(HXNG_MAPPED);

export const hxngStatusSchema = z.nativeEnum(HXNG_STATUS);

export const medicineCategorySchema = z.union([
    z.literal('advice'),
    z.literal('device'),
    z.literal('nad'),
]);

export const medicationsEntitySchema = medDoseInfoSchema
    .extend(pxElSourceTrackSchema.shape)
    .extend({
        name: z.string(),
        id: z.string(),
        dosage_form: z.string().optional(),
        form: z.string().optional(),
        product_type: z.string().optional(),
        generic_name: z.string().optional(),
        generic_id: z.string().optional(),
        df_id: z.string().optional(),
        tapering_dose: z.array(medDoseInfoSchema).optional(),
        soa: z.boolean().optional(),
        actual_name: z.string().optional(),
        is_otc: z.boolean().optional(),
        manufacturer_name: z.string().optional(),
        manufacturer_id: z.string().optional(),
        med_cat: medicineCategorySchema.optional(),
        hxng_mapped: hxngMappedSchema.optional(),
        hxng_status: hxngStatusSchema.optional(),
    });

export const symDiaStatusSchema = z.object({
    code: z.string(),
    display: z.string(),
});

export const severitySchema = z.object({
    code: z.string(),
    display: z.string(),
});

export const selectionEntitySchema = z.object({
    value: z.union([z.string(), z.number()]),
    unit: z.string().optional(),
    id: z.string().optional(),
});

export const symDiaPropertySchema = z.object({
    name: z.string(),
    selection: z.array(selectionEntitySchema).optional(),
});

export const genieItemSchema = z.object({
    meta: z
        .object({
            updatedAt: z.number().optional(),
            isLocal: z.number().optional(),
            fCount: z.number().optional(),
            do_not_purge: z.boolean().optional(),
        })
        .optional(),
});

export const padFDFormElementSchema = genieItemSchema.extend({
    id: z.string(),
    name: z.string().optional(),
    value: z.string().optional(),
    icd10_name: z.string().optional(),
    icd10_code: z.string().optional(),
});

export const padDFormSchema = z.object({
    id: z.string(),
    name: z.string(),
    elements: z.array(padFDFormElementSchema).optional(),
});

export const safeSchema = z.object({
    low: z.string().optional(),
    high: z.string().optional(),
    type: z.union([z.literal('Numeric'), z.literal('string'), z.string()]),
    is_decimal_allowed: z.boolean().optional(),
    normal_value: z.string().optional(),
});

export const examinationEntitySchema = z.object({
    id: z.string(),
    name: z.string(),
    notes: z.string().optional(),
});

export const patientMedicalConditionSchema = z.object({
    id: z.string(),
    name: z.string(),
    status: z.string().optional(),
    reportedAt: z.string().optional(),
    since: z
        .object({
            custom: z.string(),
        })
        .optional(),
    notes: z.string().optional(),
});

export const familyHistorySchema = z.object({
    id: z.string(),
    name: z.string(),
    who: z.string().optional(),
    reportedAt: z.string().optional(),
    notes: z.string().optional(),
    status: z.string().optional(),
});

export const lifestyleHabitsSchema = z.object({
    id: z.string(),
    name: z.string(),
    frequency: z
        .object({
            custom: z.string(),
        })
        .optional(),
    reportedAt: z.string().optional(),
    since: z
        .object({
            custom: z.string(),
        })
        .optional(),
    notes: z.string().optional(),
    status: z.string().optional(),
});

export const recentTravelHistorySchema = z.object({
    id: z.string(),
    name: z.string(),
    notes: z.string().optional(),
    reportedAt: z.string().optional(),
    status: z.string().optional(),
});

export const currentMedicationsSchema = z.object({
    id: z.string(),
    name: z.string(),
    reportedAt: z.string().optional(),
    frequency: z
        .object({
            custom: z.string(),
        })
        .optional(),
    since: z
        .object({
            custom: z.string(),
        })
        .optional(),
    notes: z.string().optional(),
    status: z.string().optional(),
});

export const drugAllergySchema = z.object({
    id: z.string(),
    name: z.string(),
    reportedAt: z.string().optional(),
    since: z
        .object({
            custom: z.string(),
        })
        .optional(),
    notes: z.string().optional(),
    status: z.string().optional(),
    generic_id: z.string().optional(),
    generic_name: z.string().optional(),
});

export const foodOthersAllergySchema = z.object({
    id: z.string(),
    name: z.string(),
    reportedAt: z.string().optional(),
    since: z
        .object({
            custom: z.string(),
        })
        .optional(),
    notes: z.string().optional(),
    status: z.string().optional(),
});

export const pastProceduresSchema = z.object({
    id: z.string(),
    name: z.string(),
    reportedAt: z.string().optional(),
    on: z
        .object({
            mm: z.string(),
            yyyy: z.string(),
        })
        .optional(),
    notes: z.string().optional(),
    status: z.string().optional(),
});

export const otherMedicalHistorySchema = z.object({
    id: z.string(),
    name: z.string(),
    reportedAt: z.string().optional(),
    notes: z.string().optional(),
    status: z.string().optional(),
});

export const mhcSchema = z.object({
    patientMedicalConditions: z.array(patientMedicalConditionSchema).optional(),
    familyHistory: z.array(familyHistorySchema).optional(),
    lifestyleHabits: z.array(lifestyleHabitsSchema).optional(),
    recentTravelHistory: z.array(recentTravelHistorySchema).optional(),
    currentMedications: z.array(currentMedicationsSchema).optional(),
    drugAllergy: z.array(drugAllergySchema).optional(),
    foodOtherAllergy: z.array(foodOthersAllergySchema).optional(),
    pastProcedures: z.array(pastProceduresSchema).optional(),
    otherMedicalHistory: z.array(otherMedicalHistorySchema).optional(),
});

export const diagnosisEntityOrSymptomsEntitySchema = z.object({
    name: z.string(),
    id: z.string(),
    duration: durationSchema.optional(),
    severity: severitySchema.optional(),
    status: symDiaStatusSchema.optional(),
    remark: z.string().optional(),
    isLocal: z.boolean().optional(),
    properties: z.record(symDiaPropertySchema).optional(),
    icd10_code: z.string().optional(),
    icd10_name: z.string().optional(),
});

export const createReferalDataSchema = z.object({
    s_name: z.string().optional(),
    name: z.string().optional(),
    id: z.number().optional(),
    docid: z.string().optional(),
    group_id: z.string().optional(),
    patientid: z.string().optional(),
    note: z.string().optional(),
    eka_note: z.string().optional(),
    refer_to_eka: z.boolean().optional(),
    campaign: z.boolean().optional(),
    created_at: z.string().optional(),
    clinic: doctorReferClinicAddressSchema.optional(),
    doc: z.array(docEntitySchema),
    visitId: z.string().optional(),
    referred_doctor_url: z.string().optional(),
    referred_doctor_oid: z.string().optional(),
    doc_name: z.string().optional(),
    doc_phone: z.string().optional(),
    is_appreciated: z.boolean().optional(),
    prescriptionId: z.string().optional(),
    type: z.string().optional(),
    archived: z.boolean().optional(),
});

export const labReferSchema = z.object({
    s_name: z.string(),
    name: z.string(),
    id: z.number().optional(),
    group_id: z.string().optional(),
    patientid: z.string(),
    note: z.string().optional(),
    eka_note: z.string().optional(),
    refer_to_eka: z.boolean(),
    campaign: z.boolean(),
    created_at: z.string(),
    lab: z.array(docNetworkEntitySchema),
});

export const dentalProcedureSchema = z.object({
    entity_id: z.string().optional(),
    id: z.string(),
    name: z.string(),
    teeth_ids: z.array(z.string()).optional(),
    surfaces: z.array(surfaceSchema).optional(),
    visits: z.string().optional(),
    start_on: z.string().optional(),
    remark: z.string().optional(),
    service_id: z.string().optional(),
    conducted_by: z.string().optional(),
    assisted_by: z.string().optional(),
    index: z.number().optional(),
});

export const valueSchema = z.object({
    qt: z.union([z.string(), z.number()]),
    unit: z.string(),
    code: z.string().optional(),
    code_id: z.string().optional(),
    safe: safeSchema.optional(),
});

export const vitalsEntitySchema = z.object({
    name: z.string(),
    dis_name: z.string(),
    id: z.string(),
    value: valueSchema,
    interpretation: z.string().optional(),
    date: z.string().optional(),
    isoDate: z.string().optional(),
    remark: z.string().optional(),
    locked: z.boolean().optional(),
});

export const toolSchema = z.object({
    dyform: z.array(padDFormSchema).optional(),
    language: z.string().optional(),
    diagnosis: z.array(diagnosisEntityOrSymptomsEntitySchema).optional(),
    symptoms: z.array(diagnosisEntityOrSymptomsEntitySchema).optional(),
    medications: z.array(medicationsEntitySchema).optional(),
    injections: z.array(injectionsEntitySchema).optional(),
    labTests: z.array(labTestsEntityOrProceduresEntitySchema).optional(),
    followup: followupSchema.optional(),
    advices: z.array(advicesEntitySchema).optional(),
    prescriptionNotes: notesSchema.optional(),
    privateNotes: notesSchema.optional(),
    medicalHistory: z
        .object({
            patientHistory: mhcSchema.optional(),
            examinations: z.array(examinationEntitySchema).optional(),
            vitals: z.array(vitalsEntitySchema).optional(),
        })
        .optional(),
    meta: z
        .object({
            templateId: z.string().optional(),
        })
        .optional(),
    refer: createReferalDataSchema.optional(),
    labRefer: labReferSchema.optional(),
    labVitals: z.array(labVitalEntitySchema).optional(),
    attachment: attachmentSchema.optional(),
    dentalExaminations: z.array(dentalExaminationSchema).optional(),
    dentalProcedures: z.array(dentalProcedureSchema).optional(),
    administeredVaccines: z.array(iVaccineStatusSchema).optional(),
    milestones: z.array(iMilestoneHistorySchema).optional(),
    allMilestones: z.array(iMilestoneHistorySchema).optional(),
    vaccinationHistory: z.array(iVaccineStatusSchema).optional(),
    opVision: z.array(opVisionElementSchema).optional(),
    opIop: z.array(opIopElementSchema).optional(),
    opCurrentSpec: z.array(opSpecElementSchema).optional(),
    opSubjectiveRefraction: z.array(opSpecElementSchema).optional(),
    opAutoRefraction: z.array(opSpecElementSchema).optional(),
    opFinalPrescription: z.array(opSpecElementSchema).optional(),
    procedures: z.array(procedureSchema).optional(),
    ipdAdmission: ipdAdmissionSchema.optional(),
    careCanvas: z.array(careCanvasSchema).optional(),
});
